import DeliveryTimes from './DeliveryTimes'

export default DeliveryTimes


// WEBPACK FOOTER //
// ./src/features/OrderDetails/components/DeliveryTimes/index.js